import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import dayjs from "dayjs";
import { Link as RouteLink, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import store, { RootState } from "../../../../store/store";
import CustomSpinner from "../../../../shared/components/customSpinner/customSpinner";
import { useMemo, useState } from "react";
import sortIcon from "../../../shared/assets/sort-icon.svg";
import sortableColumn from "../../../shared/assets/sortable-column.svg";
import "./dashboardRateContract.scss";
import { Button, TableSortLabel, Typography } from "@mui/material";
import { PLATFORM_PERMISSIONS } from "../../../../shared/models/abacConfig";
import "./dashboardRateContract.scss";
import ErrorPopup from "../../../../components/dialogBox/errorModal";
import PermissionsGate from "../../../../components/privateRoute/permissionsGate";
import { PAGES_URL } from "../../../../shared/constants/constants";

interface Column {
  id: string;
  label: string;
  colSpan?: number;
  enableSort?: boolean;
  format?: (value: number) => string;
  width?: string;
}

const DashboardRateContractTable = ({
  sort,
  onSort,
  rateContractListData,
}: any) => {
  const storeRateContractState = useSelector(
    (state: RootState) => state.rateContract
  );
  const [error, setError] = useState({ open: false, message: "" });
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const ColumnRC: readonly Column[] = [
    {
      id: "rateContractName",
      label: "Rate Contract Name",
      colSpan: 1,
      enableSort: true,
    },
    {
      id: "FromParty",
      label: "Site Name",
      colSpan: 1,
      enableSort: false,
    },
    {
      id: "createdDate",
      label: "Posted date",
      colSpan: 1,
      enableSort: true,
    },
    {
      id: "validTillDate",
      label: "Valid Till",
      colSpan: 1,
      enableSort: true,
    },
    {
      id: "rateContractAmountLimit",
      label: "Contract Limit",
      colSpan: 1,
      enableSort: false,
    },
  ];
  const handleCloseError = () => {
    setError({ ...error, open: false });
  };

  const el = useMemo(() => {
    switch (storeRateContractState.loading) {
      case true:
      case undefined:
        return (
          <TableRow sx={{ height: "500px" }}>
            <TableCell colSpan={ColumnRC.length}>
              <CustomSpinner size={"2rem"} />
            </TableCell>
          </TableRow>
        );
      case false:
        return rateContractListData?.rateContracts?.length ? (
          rateContractListData.rateContracts.map((row: any) => {
            const initialQty = 0;
            const totalQuantity = row?.items.reduce(
              (accumulator: any, currentValue: any) =>
                accumulator + +currentValue?.quantity,
              initialQty
            );
            // const statusId = row?.statusId === 'REQUEST_APPROVED' &&
            // row?.expectedQuoteDate &&
            // new Date(row.expectedQuoteDate)
            //   .toISOString()
            //   .split('T')[0] <
            // new Date().toISOString().split('T')[0] ? RFQ_STATUS['REQUEST_CLOSED']
            // : RFQ_STATUS[row.statusId]
            // const className = getRFQColor(statusId)
            return (
              <TableRow key={row._id}>
                <TableCell scope="row">
                  <RouteLink
                    to={`${PAGES_URL.ORDERMGR}/${PAGES_URL.RATE_CONTRACT_VIEW}/${row._id}`}
                    style={{
                      textDecoration: "none",
                      color: "rgba(8, 115, 187, 1)",
                    }}
                    state={{ from: pathname }}
                  >
                    {row.rateContractName}
                  </RouteLink>
                </TableCell>

                <TableCell>{row?.fromPartyId?.details?.groupName}</TableCell>

                <TableCell sx={{ color: "rgba(41, 45, 50, 1)" }}>
                  {dayjs(row?.createdDate).format("DD/MM/YYYY")}
                </TableCell>
                <TableCell sx={{ color: "rgba(41, 45, 50, 1)" }}>
                  {dayjs(row?.validTillDate).format("DD/MM/YYYY")}
                </TableCell>
                <TableCell>
                  {row?.rateContractAmountLimit?.toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                        style: "currency",
                        currency: "INR",
                      })}
                </TableCell>
                {/* <TableCell>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#22438C",
                      borderRadius: 0,
                      "&:hover": { backgroundColor: "#22438C", opacity: "80%" },
                    }}
                    onClick={() =>
                      navigate(
                        `${PAGES_URL.ORDERMGR}/${PAGES_URL.CREATE_ORDER}`,
                        {
                          state: {
                            contractId: row?._id,
                          },
                        }
                      )
                    }
                  >
                    <Typography fontSize={14} textTransform={"none"}>
                      Create Order
                    </Typography>
                  </Button>
                </TableCell> */}
              </TableRow>
            );
          })
        ) : (
          <TableRow>
            <TableCell colSpan={ColumnRC.length}>No Data</TableCell>
          </TableRow>
        );
    }
  }, [ColumnRC.length, rateContractListData, storeRateContractState.loading]);

  return (
    <TableContainer className="RequestTable">
      <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 800 }}>
        <TableHead>
          <PermissionsGate permissions={[PLATFORM_PERMISSIONS.REQUEST_VIEW]}>
            <TableRow>
              {ColumnRC.map((column) => (
                <TableCell
                  key={column.id}
                  colSpan={column.colSpan}
                  width={column.width}
                >
                  {/* {column.enableSort && 
                  <TableSortLabel className={sort.type === column.id && sort.value === "desc" ? 'sortColumn inverted' : 'sortColumn' }
                    active={true}
                    direction={sort.value}
                    hideSortIcon={true}
                    onClick={() => onSort(column.id)}
                    IconComponent={ () => {
                      if (sort.type !== column.id) {
                        return <img src={sortableColumn}></img>
                      } else {
                        return <img src={sortIcon}></img>
                      }
                    }}
                    >
                    <p>{column.label}</p>

                  </TableSortLabel>
                <Typography>{column.label}</Typography>
                }

                {!column.enableSort && column.label} */}
                  <Typography fontWeight={600}>{column.label}</Typography>
                </TableCell>
              ))}
            </TableRow>
          </PermissionsGate>
        </TableHead>
        <TableBody>{el}</TableBody>
      </Table>
      <ErrorPopup
        open={error.open}
        message={error.message}
        onClose={handleCloseError}
      />
    </TableContainer>
  );
};
export default DashboardRateContractTable;
